import {
  addPicTypeApi,
  updatePicTypeApi,
  getPicTypeListApi,
  addPicLibApi,
  deletePicLibApi,
  queryPicLibApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  添加图片类型信息
  async addPicTypeAction(context, param) {
    const res = await addPicTypeApi(param)
    return res
  },
  //  修改图片类型信息
  async updatePicTypeAction(context, param) {
    const res = await updatePicTypeApi(param)
    return res
  },
  //  获取图片类型列表信息
  async getPicTypeListAction(context, param) {
    const res = await getPicTypeListApi(param)
    return res
  },
  //  获取图片类型列表信息
  async addPicLibAction(context, param) {
    const res = await addPicLibApi(param)
    return res
  },
  //  删除图库信息
  async deletePicLibAction(context, param) {
    const res = await deletePicLibApi(param)
    return res
  },
  //  查询图库信息
  async queryPicLibAction(context, param) {
    const res = await queryPicLibApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
